import gql from 'graphql-tag';

const archiveAssetMutation = gql`
    mutation ArchiveAssetMutation($assetId: String!) {
        archiveAsset(assetId: $assetId) {
            assetId
        }
    }
`;

export default (() => ({
  mutation: archiveAssetMutation,
  module: 'assets',
  buildVariables: (assetId) => ({
    assetId
  })
}));